import _ from 'lodash'
import isNullOrUndefined from './is-null-or-undefined'

/**
 * getUpdateProfileFormInitialValues
 * base on form config to generate a initial value for update profile form
 *
 * @param { formConfig, userData, defaultCountryCallingCode }
 */
export default function getUpdateProfileFormInitialValues({
  formConfig = {},
  userData = {},
  defaultCountryCallingCode = '',
}) {
  const countryCallingCode = (
    _.get(userData, 'tenantPhoneData.countryCallingCode')
    || _.get(userData, 'phoneData.countryCallingCode')
    || defaultCountryCallingCode
  ).replace(/^\+/, '')
  const userPhone = _.get(userData, 'tenantPhone') || _.get(userData, 'phone', 'NoPhoneNumber')
  const phoneRegExpObj = RegExp(`^(?:\\+*${countryCallingCode})(?<localPhoneNumber>[0-9_*#-]+)`)
  const localPhoneNumber = _.get(phoneRegExpObj.exec(userPhone), 'groups.localPhoneNumber', '')
  return _.reduce(formConfig, (result, current, key) => {
    let newResult = {
      ...result,
      [key]: _.get(userData, key, _.includes(['meta', key]) ? {} : ''),
    }
    if (/^meta[A-Z]/.test(key)) {
      newResult = {
        ...result,
        [key]: _.get(userData, `meta.${_.camelCase(_.replace(key, /^meta/, ''))}`, ''),
      }
    }
    switch (key) {
      case 'phone':
      case 'tenantPhone':
        newResult.token = ''
        newResult.countryCallingCode = countryCallingCode
        newResult.localPhoneNumber = localPhoneNumber
        break
      case 'email':
        if (current.requireConfirmation === true) {
          newResult.emailConfirmation = ''
        }
        break
      case 'password':
        if (current.requireConfirmation === true) {
          newResult.passwordConfirmation = ''
        }
        break
      case 'screenName':
        if (isNullOrUndefined(_.get(userData, 'screenName'))) {
          newResult.screenName = _.get(userData, 'alias', '')
        }
        break
      default:
        break
    }
    return newResult
  }, {})
}
